export default __webpack_public_path__ + "static/media/1316.8f6d91d4.png";